import dynamic from "next/dynamic";
import YoutubeTextAndAssetConfig from "./youtube-text-and-asset-config";
import YoutubeTextAndAssetAdvancedConfig from "./youtube-text-and-asset-advanced-config";
const YoutubeTextAndAssetComponent = dynamic(()=>import("./youtube-text-and-asset-component"));
export default {
    YoutubeTextAndAssetComponent,
    YoutubeTextAndAssetConfig,
    YoutubeTextAndAssetAdvancedConfig
};
